import type { Shop } from '@prisma/client'
import type { SerializeFrom } from '@remix-run/server-runtime'
import { useMemo } from 'react'

import invariant from '~/utils/invariant'

import { useMatchesData } from './use-matches-data'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isSerializedShop(shop: any): shop is SerializeFrom<Shop> {
  return (
    shop &&
    typeof shop === 'object' &&
    typeof shop.name === 'string' &&
    typeof shop.createdAt === 'string'
  )
}

export function useOptionalShop(): Shop | undefined {
  const data = useMatchesData('routes/__shop')

  const result = useMemo(() => {
    if (!data || !isSerializedShop(data.shop)) {
      return undefined
    }

    return {
      ...data.shop,
      publishedAt: data.shop.publishedAt
        ? new Date(data.shop.publishedAt)
        : null,
      crossSellingEnabledAt: data.shop.crossSellingEnabledAt
        ? new Date(data.shop.crossSellingEnabledAt)
        : null,
      createdAt: new Date(data.shop.createdAt),
      updatedAt: new Date(data.shop.updatedAt),
    }
  }, [data])

  return result
}

export function useShop(): Shop {
  const maybeShop = useOptionalShop()
  invariant(
    maybeShop,
    'No shop found in shop loader, but shop is required by useShop'
  )
  return maybeShop
}
